import { CreateAnAccount } from "../../components/CreateAnAccount/CreateAnAccount"

export const CreateAccount =()=>{
    return(
        <div>
            <CreateAnAccount />
        </div>
    )
}
